import type React from 'react';

import CallSplitRoundedIcon from '@mui/icons-material/CallSplitRounded';
import DesignServicesRoundedIcon from '@mui/icons-material/DesignServicesRounded';
import NavigationOutlinedIcon from '@mui/icons-material/NavigationRounded';
import { Resources } from '@ragu-components/ord-resources';
import { CallflowReadFields } from '@ragu-components/ord-types';

import { Flowchart } from 'src/components/flowchart/Flowchart';

import MobilityEditForm from './MobilityEditForm';
import mobilityNodeTypes from './mobilityNodeTypes';

import type { NodeMenuConfig } from 'src/components/flowchart/dataProvider/types';
import type { FlowchartProps } from 'src/components/flowchart/Flowchart';

export const nodeMenuConfig: NodeMenuConfig = [
  {
    icon: CallSplitRoundedIcon,
    label: 'callflows.interface.rules',
    items: [
      { name: 'mapping', label: 'callflows.nodes.mapping.name' },
      { name: 'presence_router', label: 'callflows.nodes.presence_router.name' },
      { name: 'response_router', label: 'callflows.nodes.response_router.name' },
      { name: 'is_external', label: 'callflows.nodes.is_external.name' },
      { name: 'is_from_queue', label: 'callflows.nodes.is_from_queue.name' },
    ],
  },
  {
    icon: DesignServicesRoundedIcon,
    label: 'callflows.interface.services',
    items: [
      { name: 'hunt', label: 'callflows.nodes.hunt.name' },
      { name: 'queue', label: 'callflows.nodes.queue.name' },
      { name: 'disconnect', label: 'callflows.nodes.disconnect.name' },
      { name: 'forward', label: 'callflows.nodes.forward.name' },
      { name: 'personal_voicemail', label: 'callflows.nodes.personal_voicemail.name' },
      { name: 'calendar', label: 'callflows.nodes.calendar.name' },
    ],
  },
  {
    icon: NavigationOutlinedIcon,
    label: 'callflows.interface.destinations',
    items: [
      { name: 'user', label: 'callflows.nodes.user.name' },
      { name: 'call_me', label: 'callflows.nodes.call_me.name' },
    ],
  },
];

export const Mobility = ({
  isPersonal,
  initialData = undefined,
  ...props
}: Omit<FlowchartProps, 'editForm' | 'nodeMenuConfig' | 'resource'>): React.ReactElement => {
  return (
    <Flowchart
      editForm={<MobilityEditForm isPersonal={isPersonal} />}
      nodeMenuConfig={nodeMenuConfig}
      backupVersionField={`${CallflowReadFields.latest_callflow_version}.id`}
      nodeTypes={mobilityNodeTypes}
      resource={Resources.mobility_configurations}
      isPersonal={isPersonal}
      initialData={initialData}
      {...props}
    />
  );
};

export default Mobility;
